"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var regex = /^\/jobs/i;

exports["default"] = function (path) {
  return regex.test(path);
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/is-search-results-path.js
 ** module id = 523
 ** module chunks = 0
 **/